import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import { actions } from 'react-redux-form';
import ArrowButton from '../../../../common/button-arrow';
import GameLevelFormColumn from './game-level-form-column';
class GameLevelForm extends Component {
  constructor(props) {
    super(props);
  }

  handleAddColumn = () => {
    if (this.gameLevels().length <= 2) {
      const { game, dispatch } = this.props;
      const newGame = cloneDeep(game);
      const level = Object.keys(newGame.game_levels).length + 1;

      newGame.game_levels[`level-${level}`] = {};
      newGame.game_levels[`level-${level}`]['minimum-number-of-outers'] = { value: 0 };
      newGame.game_levels[`level-${level}`]['prize-amount'] = { value: 0 };
      dispatch(actions.change('deep.admin_game', newGame));
    }
  };

  handleRemoveColumn = () => {
    if (this.gameLevels().length >= 2) {
      const { game, dispatch } = this.props;
      const newGame = cloneDeep(game);
      const level = Object.keys(newGame.game_levels).length;

      if (newGame.game_levels[`level-${level}`]['id']) {
        newGame.game_levels[`level-${level}`]['_destroy'] = true;
      } else {
        delete newGame.game_levels[`level-${level}`];
      }
      dispatch(actions.change('deep.admin_game', newGame));
    }
  };

  isLast = (index) => {
    if (index + 1 === 1) {
      return false;
    }

    return this.gameLevels().length === index + 1;
  }

  gameLevels = () => {
    const { game } = this.props;
    
    return game && game.game_levels && Object.values(game.game_levels) || [];
  }

  render() {
    const { game, hasNoLevels } = this.props;
    const gameLevels = game && game.game_levels && Object.values(game.game_levels) || [];

    return (
      <div className="container-fluid">
        <Row>
          {gameLevels.length !== 0 && gameLevels.filter((gameLevel) => !gameLevel['_destroy']).map((gameLevel, index) =>
            (<GameLevelFormColumn
              key={index}
              level={index + 1}
              isLast={this.isLast(index)}
              hasNoLevels={hasNoLevels}
              handleAddColumn={this.handleAddColumn}
              handleRemoveColumn={this.handleRemoveColumn} />))}
        </Row>
        <Row>
          <Col md={2}>
            <ArrowButton
              arrow={false}
              submit={false}
              color="red"
              onClick={this.handleAddColumn}
              disabled={hasNoLevels}>
                Add game level
            </ArrowButton>
          </Col>
          <Col md={2}>
            <ArrowButton
              arrow={false}
              submit={false}
              color="red"
              onClick={this.handleRemoveColumn}
              disabled={hasNoLevels}>
                Remove game level
            </ArrowButton>
          </Col>
          <Col md={8}></Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  game: state.deep.admin_game,
  hasNoLevels: state.deep.admin_game.has_no_levels
});

export default connect(mapStateToProps)(GameLevelForm);



// WEBPACK FOOTER //
// ./src/components/admin/games/game-levels/form/game-level-form.jsx